module.exports = __webpack_public_path__ + "assets/ubike0.jpg?c188ac2f34e64eebb73e237b5b9b9e65";